import { Map, fromJS } from 'immutable';

const KEY = 'single';

export function request(state, { id }) {
    let items = state.get('items') || Map();

    items = items.mergeIn([ id, KEY ], (items.getIn([ id, KEY ]) || Map()).set('_state', 'IN_PROGRESS') );

    return state.set('items', items);
}

export function error(state, { id, errors }) {
    let items = state.get('items') || Map();

    if ( items.getIn([ id, KEY ])) {
        items = items.mergeIn([ id, KEY ], items.getIn([ id, KEY ]).set('_state', 'ERROR').set('errors', fromJS(errors)) );
    }

    return state.set('items', items);
}

export function finish(state, { id, liabilities }) {
     // Update item only if it was already added
    if (state.hasIn([ 'items', id, KEY ] )) {
        return state.mergeIn([ 'items', id, KEY ], fromJS({
            _state: 'FINISHED',
            liabilities
        }));
    }

    return state;
}
